export default "__VITE_ASSET__BVDUE1wt__"